import type { AcqInvoiceDetail } from "@/lib/api/acquisitions";

type AcqInvoiceLinesTableProps = {
  lines: AcqInvoiceDetail["lines"];
  totalAmount: number;
  formatCurrency: (n: number) => string;
};

export function AcqInvoiceLinesTable({
  lines,
  totalAmount,
  formatCurrency,
}: AcqInvoiceLinesTableProps) {
  return (
    <div className="overflow-hidden rounded-lg border border-slate-200 bg-white">
      <div className="border-b border-slate-100 px-4 py-3">
        <h2 className="text-sm font-semibold text-slate-900">Invoice lines</h2>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-slate-100 bg-slate-50/80 text-left">
              <th className="px-4 py-2.5 font-medium text-slate-600">Description</th>
              <th className="px-4 py-2.5 font-medium text-slate-600">PO line</th>
              <th className="px-4 py-2.5 text-right font-medium text-slate-600">Qty</th>
              <th className="px-4 py-2.5 text-right font-medium text-slate-600">Unit price</th>
              <th className="px-4 py-2.5 text-right font-medium text-slate-600">Total</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {lines.map((line) => (
              <tr key={line.id}>
                <td className="px-4 py-2.5 text-slate-800">
                  {line.description || line.poLine?.title || "—"}
                </td>
                <td className="px-4 py-2.5 text-slate-500">
                  {line.poLine
                    ? `${line.poLine.title}${line.poLine.isbn ? ` · ${line.poLine.isbn}` : ""}`
                    : "—"}
                </td>
                <td className="px-4 py-2.5 text-right tabular-nums text-slate-800">
                  {line.quantity}
                </td>
                <td className="px-4 py-2.5 text-right tabular-nums text-slate-800">
                  {formatCurrency(Number(line.unitPrice))}
                </td>
                <td className="px-4 py-2.5 text-right tabular-nums font-medium text-slate-900">
                  {formatCurrency(Number(line.unitPrice) * line.quantity)}
                </td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr className="border-t border-slate-200 bg-slate-50/80">
              <td className="px-4 py-2.5 font-semibold text-slate-900" colSpan={4}>
                Total
              </td>
              <td className="px-4 py-2.5 text-right text-base font-semibold tabular-nums text-slate-900">
                {formatCurrency(Number(totalAmount))}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
}
